import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
export const EASE = [0.23, 1, 0.32, 1] as const;
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li' | 'section';
}
export function Reveal({
  children,
  delay = 0,
  className = '',
  as = 'div'
}: RevealProps) {
  const reduce = useReducedMotion();
  const Component = motion[as];
  if (reduce) {
    return <Component className={className} data-id="element-81" data-mp="2jrhucrlnex2w">{children}</Component>;
  }
  return <Component initial={{
    opacity: 0,
    y: 22
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    duration: 0.3,
    ease: EASE,
    delay
  }} className={className} data-id="element-82" data-mp="2nri96dcntaah">
      {children}
    </Component>;
}